import { useEffect } from 'react';
import { useVIPStatus } from '@hooks/useVIPStatus';
import { useBanners } from '@hooks/useBanners';

function BannerAds() {
    const { isVIP } = useVIPStatus();
    const { banners } = useBanners();

    // Don't show banners for VIP users
    if (isVIP) return null;

    const mobileBanner = banners.mobile || {};
    const desktopBanner = banners.desktop || {};

    return (
        <section className="banner-ads" style={{ display: 'block' }}>
            {/* Mobile Banner */}
            <div className="mobile-banner">
                <a
                    href={mobileBanner.targetUrl || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="banner-link"
                >
                    <img
                        src={mobileBanner.imageUrl || 'https://imagizer.imageshack.com/img924/2028/rCwzXh.gif'}
                        alt="Mobile Banner Ad"
                        className="banner-image"
                    />
                </a>
            </div>

            {/* Desktop Banner */}
            <div className="desktop-banner">
                <a
                    href={desktopBanner.targetUrl || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="banner-link"
                >
                    <img
                        src={desktopBanner.imageUrl || 'https://imagizer.imageshack.com/img923/9748/8t6nNE.gif'}
                        alt="Desktop Banner Ad"
                        className="banner-image"
                    />
                </a>
            </div>
        </section>
    );
}

export default BannerAds;
